import { db } from '@/main';
import moment from 'moment'

const state = {
    todo : []
}

// getters
const getters = {
}

// mutations
const mutations = {
    tododelete:(state,payload)=>{
        db.collection('IAPLog').doc(payload).delete()
    },
    retrieveTodos(state,todos){
        state.todo = todos
    }
};

// actions
const actions = {
    retrieveTodos:(context)=>{
        db.collection('IAPLog').get()
        .then((querySnapshot)=>{
            var tempTodos = []

            querySnapshot.forEach((doc)=>{
                
                tempTodos.push({ 
                    id:doc.id,
                    userUid:doc.data().userUid, 
                    cost:doc.data().cost, 
                    market:doc.data().market,
                    productId:doc.data().productId,                    
                    purchaseOrderId:doc.data().purchaseOrderId,
                    purchaseSignature:doc.data().purchaseSignature,
                    purchaseToken:doc.data().purchaseToken,
                    purchaseDate:moment(String(doc.data().purchaseDate.toDate())).format('YYYY-MM-DD hh:mm'),
                    developerPayload:doc.data().developerPayload,                    
                    created:moment(String(doc.data().created.toDate())).format('YYYY-MM-DD hh:mm'),                    
                    status:doc.data().status                    
                 });
            })
            var tempTodosSorted = tempTodos.sort((a,b)=>{
                return a.created.seconds - b.created.seconds
            })
            context.commit('retrieveTodos',tempTodosSorted)
        })
    },
    tododelete:(context, payload) => {
        context.commit('tododelete',payload)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}